// extracted by mini-css-extract-plugin
export const main = "selfieModal-module--main--ZoM2V";
export const open = "selfieModal-module--open--3tTOb";
export const wrapper = "selfieModal-module--wrapper--1Yc0p";
export const imgWrapper = "selfieModal-module--imgWrapper--2F59R";
export const menu = "selfieModal-module--menu--o5cXT";